import { render } from "./WaveMask.vue?vue&type=template&id=b648e88e&scoped=true"
import script from "./WaveMask.vue?vue&type=script&lang=js"
export * from "./WaveMask.vue?vue&type=script&lang=js"

import "./WaveMask.vue?vue&type=style&index=0&id=b648e88e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b648e88e"]])

export default __exports__